import { Injectable } from "@angular/core";

import { MapperInterface } from "./mapper-inteface";
import { MapperProcedimento } from "./mapper-procedimento";
import { AnagraficaBeneficiarioDTO } from "../dto/anagrafica-beneficiarioDTO";
import { AnagraficaBeneficiarioVO } from "../vo/anagrafica-beneficiarioVO";
import { MapperDocumentoSpesa } from "./mapper-documento-spesa";

@Injectable({ providedIn: "root" })
export class MapperAnagraficaBeneficiario
  implements
  MapperInterface<AnagraficaBeneficiarioDTO, AnagraficaBeneficiarioVO> {
  constructor(private documentoSpesaMapper: MapperDocumentoSpesa) { }

  convertVoToDto(
    anagraficaBeneficiarioVO: AnagraficaBeneficiarioVO
  ): AnagraficaBeneficiarioDTO {
    if (anagraficaBeneficiarioVO != null) {
      const anagraficaBeneficiarioDTO = new AnagraficaBeneficiarioDTO();
      anagraficaBeneficiarioDTO.denominazione =
        anagraficaBeneficiarioVO.denominazione;
      anagraficaBeneficiarioDTO.tipoBeneficiario = anagraficaBeneficiarioVO.tipoBeneficiario;
      anagraficaBeneficiarioDTO.codiceFiscale = anagraficaBeneficiarioVO.codiceFiscale;
      anagraficaBeneficiarioDTO.partitaIva = anagraficaBeneficiarioVO.partitaIva;
      anagraficaBeneficiarioDTO.indirizzo = anagraficaBeneficiarioVO.indirizzo;
      anagraficaBeneficiarioDTO.classeContabile =
        anagraficaBeneficiarioVO.classeContabile;
      anagraficaBeneficiarioDTO.codiceFornitore =
        anagraficaBeneficiarioVO.codiceFornitore;
      anagraficaBeneficiarioDTO.iban = anagraficaBeneficiarioVO.iban;
      anagraficaBeneficiarioDTO.documentiSpesa = this.documentoSpesaMapper.convertListVoToDto(anagraficaBeneficiarioVO.documentiSpesa);
      anagraficaBeneficiarioDTO.comune = anagraficaBeneficiarioVO.comune;
      anagraficaBeneficiarioDTO.cap = anagraficaBeneficiarioVO.cap;
      anagraficaBeneficiarioDTO.provincia = anagraficaBeneficiarioVO.provincia;
      anagraficaBeneficiarioDTO.ritenuta = anagraficaBeneficiarioVO.ritenuta;
      anagraficaBeneficiarioDTO.protocolliDomanda = anagraficaBeneficiarioVO.protocolliDomanda;
      anagraficaBeneficiarioDTO.codiceCor = anagraficaBeneficiarioVO.codiceCor;
      anagraficaBeneficiarioDTO.noteAggiuntive = anagraficaBeneficiarioVO.noteAggiuntive;

      return anagraficaBeneficiarioDTO || new AnagraficaBeneficiarioDTO();
    } else {
      return null;
    }
  }

  convertDtoToVo(
    anagraficaBeneficiarioDTO: AnagraficaBeneficiarioDTO
  ): AnagraficaBeneficiarioVO {
    if (anagraficaBeneficiarioDTO != null) {
      const anagraficaBeneficiarioVO = new AnagraficaBeneficiarioVO();
      anagraficaBeneficiarioVO.denominazione =
        anagraficaBeneficiarioDTO.denominazione;
      anagraficaBeneficiarioVO.tipoBeneficiario = anagraficaBeneficiarioDTO.tipoBeneficiario;
      anagraficaBeneficiarioVO.codiceFiscale = anagraficaBeneficiarioDTO.codiceFiscale;
      anagraficaBeneficiarioVO.partitaIva = anagraficaBeneficiarioDTO.partitaIva;
      anagraficaBeneficiarioVO.indirizzo = anagraficaBeneficiarioDTO.indirizzo;
      anagraficaBeneficiarioVO.classeContabile =
        anagraficaBeneficiarioDTO.classeContabile;
      anagraficaBeneficiarioVO.codiceFornitore =
        anagraficaBeneficiarioDTO.codiceFornitore;
      anagraficaBeneficiarioVO.iban = anagraficaBeneficiarioDTO.iban;
      anagraficaBeneficiarioVO.documentiSpesa = this.documentoSpesaMapper.convertListDtoToVo(anagraficaBeneficiarioDTO.documentiSpesa);
      anagraficaBeneficiarioVO.ritenuta = anagraficaBeneficiarioDTO.ritenuta;
      anagraficaBeneficiarioVO.comune = anagraficaBeneficiarioDTO.comune;
      anagraficaBeneficiarioVO.cap = anagraficaBeneficiarioDTO.cap;
      anagraficaBeneficiarioVO.provincia = anagraficaBeneficiarioDTO.provincia;
      anagraficaBeneficiarioVO.protocolliDomanda = anagraficaBeneficiarioDTO.protocolliDomanda;
      anagraficaBeneficiarioVO.codiceCor = anagraficaBeneficiarioDTO.codiceCor;
      anagraficaBeneficiarioVO.noteAggiuntive = anagraficaBeneficiarioDTO.noteAggiuntive;


      return anagraficaBeneficiarioVO || new AnagraficaBeneficiarioVO();
    } else {
      return null;
    }
  }

  convertListVoToDto(
    anagraficaVOList: AnagraficaBeneficiarioVO[]
  ): AnagraficaBeneficiarioDTO[] {
    if (anagraficaVOList != null) {
      // console.log("[MapperDocumenti] documentoDTOList => documentoVOList");

      const anagraficaDTOList = new Array<AnagraficaBeneficiarioDTO>();
      anagraficaVOList.forEach((vo) => {
        anagraficaDTOList.push(this.convertVoToDto(vo));
      });

      return anagraficaDTOList || new Array<AnagraficaBeneficiarioDTO>();
    } else {
      return new Array<AnagraficaBeneficiarioDTO>();
    }
  }

  convertListDtoToVo(
    anagraficaDTOList: AnagraficaBeneficiarioDTO[]
  ): AnagraficaBeneficiarioVO[] {
    if (
      anagraficaDTOList != null &&
      anagraficaDTOList !== undefined &&
      anagraficaDTOList.length > 0
    ) {
      // console.log("[MapperSettori] attivitaDTOList => attivitaDTOList");
      // console.log("attivitaDTOList", attivitaDTOList);
      const anagraficaVOList = new Array<AnagraficaBeneficiarioVO>();
      anagraficaDTOList.forEach((dto) => {
        anagraficaVOList.push(this.convertDtoToVo(dto));
      });

      return anagraficaVOList || new Array<AnagraficaBeneficiarioVO>();
    } else {
      return new Array<AnagraficaBeneficiarioVO>();
    }
  }
}
